import { ColumnDef } from "@tanstack/react-table";

import { GroupResponse } from "@/_v2/api/groups";
import { Checkbox } from "@/_v2/components/ui/checkbox";

export const columns: ColumnDef<GroupResponse>[] = [
  {
    id: "select",
    header: () => <Checkbox disabled={true} />,
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select group"
      />
    ),
    enableSorting: false,
    enableHiding: false,
    size: 25,
    maxSize: 25,
  },
  {
    accessorKey: "marketing_name",
    header: "Name",
    enableSorting: true,
    size: 200,
  },
  {
    accessorKey: "uuid",
    header: "Id",
    enableSorting: false,
    size: 50,
    maxSize: 50,
  },
];
